import { Breadcrumb, message, Table, type TableColumnsType } from "antd";
import moment from "moment";
import { useEffect } from "react";
import { CgScreen } from "react-icons/cg";
import { Link, useNavigate } from "react-router-dom";

import { SectionHeader } from "../../_lib/_components";
import { getUserOnboardingProgress, useAppSelector } from "../../_lib/_store";
import { type UserOnboardingProgressType } from "../../_lib/_store/interfaces/userOnboardingProgress";

export const UserOnboardingProgressPage = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const { isLoading, userOnboardingProgress } = useAppSelector(
    (state) => state.userOnboardingPorgress,
  );
  console.log(
    "🚀 ~ UserOnboardingProgressPage ~ userOnboardingProgress:",
    userOnboardingProgress,
  );
  const navigate = useNavigate();

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    await getUserOnboardingProgress(messageApi);
  };

  const columns: TableColumnsType<UserOnboardingProgressType> = [
    {
      title: "User Id",
      dataIndex: "userId",
      key: "userId",
    },
    {
      title: "Current Step Key",
      dataIndex: "currentStepKey",
      key: "currentStepKey",
    },
    {
      title: "Started At",
      dataIndex: "startedAt",
      key: "startedAt",
      render: (t) => moment(t).format("YYYY-MM-DD HH:MM"),
    },
    {
      title: "Last Updated At",
      dataIndex: "lastUpdatedAt",
      key: "lastUpdatedAt",
      render: (t) => moment(t).format("YYYY-MM-DD HH:MM"),
    },
    {
      title: "Completed At",
      dataIndex: "completedAt",
      key: "completedAt",
      render: (t) => (t ? moment(t).format("YYYY-MM-DD HH:MM") : "-"),
    },
    {
      title: "",
      dataIndex: "actions",
      key: "actions",
      width: 100,
      render: (_, obj) => (
        <CgScreen
          style={{ cursor: "pointer" }}
          onClick={() =>
            navigate("/user-onboarding-progress/show", { state: { data: obj } })
          }
        />
      ),
    },
  ];

  //   const handleMenuClick = (key: string, obj: OnboardingStepsType) => {
  //     switch (key) {
  //       case "show":
  //         navigate(`/onboarding-step/show`, {
  //           state: { onboardingStep: obj },
  //         });
  //         break;
  //       case "edit":
  //         navigate(`/onboarding-step/edit`, {
  //           state: { onboardingStep: obj },
  //         });
  //         break;
  //       case "delete":
  //         deleteOnboardingStep(messageApi, obj?.id, true);
  //         break;
  //       default:
  //         break;
  //     }
  //   };

  return (
    <>
      {contextHolder}
      <div className="tag">
        <div className="header">
          <Breadcrumb
            items={[
              {
                title: <Link to="/dashboard">Dashboard</Link>,
              },
              {
                title: "User Onboarding Progress",
              },
            ]}
          />
        </div>
        <SectionHeader
          dataLength={userOnboardingProgress?.length}
          createRoute="user-onboarding-progress"
        />
        <Table
          sticky
          dataSource={userOnboardingProgress}
          columns={columns}
          loading={isLoading}
          scroll={{ x: 1300 }}
          rowKey={"id"}
        />
      </div>
    </>
  );
};
